export class ElemInstalacionDetalleNotifImagenModel {
  Imagen: string;
  Empresa: number;
  Fecha: string;
  FechaBaja: string;
  FechaCreacion: string;
  FechaModificacion: string;
  Guid: string;
  GuidInstalacionDetalleNotificacion: string;
  Id: number;
  IdInstalacionDetalleNotificacion: number;

  constructor() { }
}
